/* The failure's actions, the program card and the assumptions box: board O. */

.bad {
  color: var(--danger-ink);
}

.acts {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.program {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  max-width: 520px;
  padding: var(--space-4) var(--space-18px);
}

.programEyebrow {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  margin: var(--space-0);
  font-size: var(--fs-note);
  font-weight: var(--fw-bold);
  color: var(--text-2);
}

.programGlyph {
  flex: none;
  width: 15px;
  height: 15px;
}

.programTitle {
  margin: var(--space-0);
  font-size: var(--fs-mode);
  font-weight: var(--fw-extrabold);
  letter-spacing: var(--ls-title);
}

.stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-1px);
  margin: var(--space-0);
  overflow: hidden;
  background: var(--border);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-12px);
}

/* The figure over its words, as the canon draws it; the words stay first in the reading order. */
.stat {
  display: flex;
  flex-direction: column-reverse;
  gap: var(--space-2px);
  justify-content: flex-end;
  padding: var(--space-9px) var(--space-3);
  background: var(--bg-sunken);
}

.stat dt {
  font-size: var(--fs-micro);
  font-weight: var(--fw-semibold);
  color: var(--text-2);
}

.stat dd {
  margin: var(--space-0);
  font-size: var(--fs-h3);
  font-weight: var(--fw-extrabold);
  letter-spacing: var(--ls-heading);
  font-variant-numeric: tabular-nums;
}

/* The draft's sessions under the figures (boards Q, R): one sunken list, a row per session, the
 * row whose panel is open raised with its letter inked. A plan whose phases train different things
 * draws one such list per phase, under the phase's name and cycles. */
.sessionGroups,
.sessionGroup {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.sessionGroups {
  gap: var(--space-3);
}

.sessionPhase {
  margin: var(--space-0);
  font-size: var(--fs-label);
  font-weight: var(--fw-bold);
  color: var(--text-2);
}

.sessions {
  display: flex;
  flex-direction: column;
  padding: var(--space-0);
  margin: var(--space-0);
  overflow: hidden;
  list-style: none;
  background: var(--bg-sunken);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-md);
}

.sessionItem + .sessionItem {
  border-top: var(--border-hairline) solid var(--border);
}

.session {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) auto 16px;
  gap: var(--space-10px);
  align-items: center;
  width: 100%;
  padding: var(--space-11px) var(--space-3);
  font-family: var(--font-body);
  color: var(--text);
  text-align: left;
  cursor: pointer;
  background: transparent;
  border: none;
}

.session:hover {
  background: var(--hover-tint);
}

.session:focus-visible {
  outline: var(--border-focus) solid var(--text);
  outline-offset: var(--outline-inset);
}

.sessionOpen,
.sessionOpen:hover {
  background: var(--buddy-raised);
}

.sessionLetter {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  font-size: var(--fs-label);
  font-weight: var(--fw-extrabold);
  color: var(--text-2);
  background: var(--buddy-raised);
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--radius-mark);
}

.sessionOpen .sessionLetter {
  color: var(--bg);
  background: var(--text);
  border-color: var(--text);
}

.sessionText {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.sessionName {
  overflow: hidden;
  font-size: var(--fs-button-sm);
  font-weight: var(--fw-bold);
  letter-spacing: var(--ls-heading);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sessionFacts,
.sessionMinutes {
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
  font-variant-numeric: tabular-nums;
  color: var(--text-2);
}

.sessionChevron {
  width: 14px;
  height: 14px;
  color: var(--text-2);
}

.sessionOpen .sessionChevron {
  color: var(--text);
}

.programNote {
  margin: var(--space-0);
  font-size: var(--fs-note);
  font-weight: var(--fw-semibold);
  color: var(--text-2);
}

.programActions {
  display: flex;
  gap: var(--space-2);
  align-items: center;
}

.warnings {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  list-style: none;
}

.warning {
  font-size: var(--fs-foot);
  line-height: var(--lh-relaxed);
  color: var(--text-2);
}

/* Which version of the draft this is, over its card (R11): quiet, said only when there are several. */
.version {
  margin: var(--space-0);
  font-size: var(--fs-note);
  font-weight: var(--fw-bold);
  color: var(--text-2);
}

/* Where an imported draft came from (board T): the file, and that it was not kept (R30). */
.origin {
  margin: var(--space-0);
  font-size: var(--fs-note);
  font-weight: var(--fw-bold);
  color: var(--text-2);
  overflow-wrap: anywhere;
}
